import { emptyAsNull } from "../../../utils";

import type { RootState } from "../store";

export const selectInstitution = (state: RootState) =>
  emptyAsNull(state.institution.data);
